import { createFileRoute, redirect } from '@tanstack/react-router'
import { CashSaleForm } from '@/features/accounting-cash-sales/cash-sale-form'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/accounting/card-credits/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_cash_sale.create'))
      throw redirect({ to: '/accounting/sales-receipts' })
  },
  component: () => <CashSaleForm initialDirection="out" />,
})
